import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { NumberFmt } from 'src/utils'
import { formatDate } from 'src/utils/formatDate'
import { selectPendingAdjustment } from '../../StockAdjustmentInBatchSeletor'
import { PendingAdjustment, TableRowItems } from '../../StockAdjustmentInBatchTypes'
import * as S from './PendingAdjustmentTable.styles'
import TableMui from 'src/components/TableMui'
import PendingAdjustmentFilter from '../PendingAdjustmentFilter/PendingAdjustmentFilter'

export default () => {
  const pendingAdjustments = useSelector(selectPendingAdjustment)
  const history = useHistory()

  const handleRowDoubleClick = (tableRow: TableRowItems) => {
    const { id }: TableRowItems = tableRow
    history.push(`/adjustments/pending-adjustments/${id}`)
  }

  const resolveTableRows = (data: PendingAdjustment[]) => data?.map((item) => (
    {
      ...item,
      user: item.user,
      createdAt: formatDate(item.createdAt),
      totalAdjustments: NumberFmt({ value: item.totalAdjustments, sufix: '' }) as string,
      id: item.id,
    }))

  return (
    <S.Wrapper>
      <PendingAdjustmentFilter/>
      <TableMui
        columns={[
          { id: 'user', label: 'Usuário' },
          { id: 'createdAt', label: 'Data da requisição' },
          { id: 'totalAdjustments', label: 'Qtd de ajustes' },
        ]}
        emptyLabel='Nenhum ajuste pendente'
        rows={resolveTableRows(pendingAdjustments)}
        onRowDoubleClick={handleRowDoubleClick}
        enablePagination
        rowsPerPageLimit={10}
        hasSorting
      />
    </S.Wrapper>
  )
}
